<div
    class="row justify-content-center"
    *ngIf="currentUserAddress == '0x33c387551e5ca235b06c59093209ac32afa9ef07'"
>
    <div class="col-md-5 col-sm-12">
        <nb-card class="tokenReleaseForm" size="medium">
            <nb-card-header
                ><h3 class="text-center">Token release</h3></nb-card-header
            >
            <nb-card-body>
                <form [formGroup]="tokenReleaseForm">
                    <div class="row mb-3">
                        <div class="col-md-12 text-center">
                            <p>Wallet address</p>
                            <input
                                required
                                nbInput
                                type="text"
                                fullWidth
                                formControlName="walletAddress"
                            />
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <button
                            nbButton
                            class="btn btnMiddle btnContrib"
                            status="primary"
                            (click)="tokenRelease()"
                            [disabled]="!this.tokenReleaseForm.valid"
                        >
                            Release tokens
                        </button>
                    </div>
                </form>
            </nb-card-body>
        </nb-card>
    </div>
    <div class="col-md-5 col-sm-12">
        <nb-card class="whitelistForm" size="medium">
            <nb-card-header
                ><h3 class="text-center">Whitelist address</h3></nb-card-header
            >
            <nb-card-body>
                <form [formGroup]="whitelistForm">
                    <div class="row mb-3">
                        <div class="col-md-12 text-center">
                            <p>Address</p>
                            <input
                                required
                                nbInput
                                type="text"
                                fullWidth
                                formControlName="whitelistAddress"
                            />
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <button
                            nbButton
                            class="btn"
                            status="primary"
                            (click)="whitelistAddress()"
                            [disabled]="false"
                        >
                            Whitelist address
                        </button>
                    </div>
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <p>
                                Whitelist status:
                                {{
                                    whitelistStatus == true
                                        ? "enabled"
                                        : "disabled"
                                }}
                            </p>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <button
                            nbButton
                            class="btn"
                            status="primary"
                            (click)="toggleWhitelistStatus()"
                        >
                            Toggle whitelist status
                        </button>
                    </div>
                </form>
            </nb-card-body>
        </nb-card>
    </div>
</div>
